var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.7498 7.64981C12.7498 10.3579 10.9393 12.6886 7.64725 12.6886C4.549 12.6886 2.5498 10.4905 2.5498 7.78241C2.5498 5.0029 4.4878 2.5498 7.6498 2.5498C10.8118 2.5498 12.6886 4.8703 12.7498 7.64981ZM2.5498 48.4498V15.2998H12.7498V48.4498H2.5498Z","fill":"black","key":0}),React.createElement("path",{"d":"M17.8509 26.632C17.8509 22.6922 17.7209 19.4002 17.5908 16.5569H26.7555L27.2094 20.9506H27.4032C28.6935 18.8825 31.8555 15.8506 37.1493 15.8506C43.6059 15.8506 48.4509 20.1728 48.4509 29.4727V48.4498H38.2509V30.9542C38.2509 26.8895 36.7031 23.7887 33.1509 23.7887C30.4428 23.7887 29.0862 25.9817 28.3748 27.7897C28.1147 28.4374 28.0509 29.3401 28.0509 30.2453V48.4498H17.8509V26.632Z","fill":"black","key":1})]);
}

Linkedin.defaultProps = {"width":"51","height":"51","viewBox":"0 0 51 51","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
